import { render, staticRenderFns } from "./EditAssetDialog.vue?vue&type=template&id=d8208b5c&scoped=true&"
import script from "./EditAssetDialog.vue?vue&type=script&lang=js&"
export * from "./EditAssetDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditAssetDialog.vue?vue&type=style&index=0&id=d8208b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8208b5c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDialog,VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8208b5c')) {
      api.createRecord('d8208b5c', component.options)
    } else {
      api.reload('d8208b5c', component.options)
    }
    module.hot.accept("./EditAssetDialog.vue?vue&type=template&id=d8208b5c&scoped=true&", function () {
      api.rerender('d8208b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/assets/EditAssetDialog.vue"
export default component.exports